"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Label = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let Label = exports.Label = /*#__PURE__*/function (Label) {
  Label["Next"] = "Next page";
  Label["Previous"] = "Previous page";
  return Label;
}({});
const PaginationButton = _ref => {
  let {
    direction,
    onClick,
    disabled = false,
    showLabel,
    label
  } = _ref;
  const buttonLabel = label || (direction === "back" ? Label.Previous : Label.Next);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "p-pagination__item"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)({
      "p-pagination__link--previous": direction === "back",
      "p-pagination__link--next": direction === "forward"
    }),
    disabled: disabled,
    onClick: onClick,
    type: "button"
  }, direction === "forward" && showLabel && /*#__PURE__*/_react.default.createElement("span", null, buttonLabel), /*#__PURE__*/_react.default.createElement("i", {
    className: "p-icon--chevron-down"
  }, buttonLabel), direction === "back" && showLabel && /*#__PURE__*/_react.default.createElement("span", null, buttonLabel)));
};
var _default = exports.default = PaginationButton;